import Container from "@mui/material/Container";
import { styled } from "@mui/material/styles";

interface StyledInputContainerProps {
  isMobile?: boolean;
}

export const StyledInputContainer = styled(Container, {
  shouldForwardProp: (prop) => prop !== "isMobile",
})<StyledInputContainerProps>(({ isMobile }) => ({
  paddingTop: "50px",
  paddingBottom: "70px",
  ...(!isMobile && {
    minWidth: "800px",
    maxWidth: "800px",
  }),
}));
